export default __webpack_public_path__ + "static/media/gallery_14.40d610d7.jpg";